export default __webpack_public_path__ + "static/media/Typescript.58fdeec0.svg";